import { Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropShadowCard } from '../../../../components/documented/DropShadowCard';
import { RadialIndicator } from '../../../../components/documented/RadialIndicator';
import getRadialConfig from '../../../../components/documented/RadialIndicator/radialConfig';
import { ActiveType } from '../../../../model/activeType';
import TimeTakenTableComponent from './TimeTakenTableComponent';

const TimedUpAndGo: React.FC = () => {
  const { t } = useTranslation('tests');
  return (
    <Grid container direction="row" spacing={12} sx={{ mt: 1, alignItems: 'stretch' }}>
      <Grid size={8}>
        <DropShadowCard title={t('subPages.tugScore')} icon="_TUGT" shadow={3}>
          <RadialIndicator
            {...getRadialConfig(ActiveType._TUG)}
            size={200}
            value={20}
            unit="m/s"
          />
        </DropShadowCard>
      </Grid>
      <Grid>
        <TimeTakenTableComponent />
      </Grid>
    </Grid>
  );
};

export default TimedUpAndGo;
